import { FeatureLayout } from '@lendica/components';
import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useCompanyNavigate } from '@lendica/hooks';
import { WarningAmber } from '@mui/icons-material';

export const ProductPaused = () => {
    const navigate = useCompanyNavigate();

    return (
        <FeatureLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    boxSizing: 'border-box',
                    px: 4,
                }}
            >
                <WarningAmber color="warning" style={{ fontSize: 80 }} />
                <Typography variant="h5" sx={{ mt: 4 }}>
                    Your product is paused. Please contact us for more information.
                </Typography>

                <Button
                    size="medium"
                    startIcon={<ArrowBackIcon />}
                    sx={{ mt: 4, mx: 2 }}
                    onClick={() => navigate('/wallet')}
                >
                    Go Back
                </Button>
            </Box>
        </FeatureLayout>
    );
};
